if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        MediaUpload,
        InspectorControls,
        InnerBlocks
    } = window.wp.editor;

    const {
        PanelBody,
        Button,
        TextControl,
        SelectControl
    } = window.wp.components;

    const { Fragment } = window.wp.element;

    const buildYouTubeEmbedUrl = (url) => {
        const match = url.match(
            /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/
        );
        if (!match) return '';

        const videoId = match[1];
        const params = new URLSearchParams({
            autoplay: '1',
            mute: '1',
            loop: '1',
            playlist: videoId,
            controls: '0',
            disablekb: '1',
            playsinline: '1',
            rel: '0',
            iv_load_policy: '3',
        });

        const siMatch = url.match(/[?&]si=([^&]+)/);
        if (siMatch) {
            params.set('si', siMatch[1]);
        }

        return `https://www.youtube-nocookie.com/embed/${videoId}?${params.toString()}`;
    };

    const isYouTubeUrl = (url) =>
        /(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/.test(url);

    registerBlockType('custom-gutenberg/hero-video', {
        title: 'Hero Video Background',
        description: 'Custom Hero Video Background',
        icon: 'video-alt3',
        category: 'custom-components',
        example: {},

        attributes: {
            videoSource: {
                type: 'string',
                default: 'local'  
            },
            videoUrl: {
                type: 'string',
                default: ''
            },
            videoId: {
                type: 'number',
                default: 0
            },
            externalUrl: {
                type: 'string',
                default: ''
            }
        },

        edit({ attributes, setAttributes }) {
            const { videoSource, videoUrl, videoId, externalUrl } = attributes;

            const onSelectVideo = (media) => {
                setAttributes({ videoUrl: media.url, videoId: media.id });
            };

            const removeVideo = () => {
                setAttributes({ videoUrl: '', videoId: 0 });
            };

            const onExternalUrlChange = (val) => {
                setAttributes({ externalUrl: val });
                if (isYouTubeUrl(val)) {
                    setAttributes({ videoSource: 'youtube' });
                }
            };

            const embedUrl = videoSource === 'youtube'
                ? buildYouTubeEmbedUrl(externalUrl)
                : externalUrl;

            const ALLOWED_BLOCKS = [
                'core/paragraph',
                'core/heading',
                'core/button',
                'core/buttons',
                'core/columns',
                'core/shortcode'
            ];

            const TEMPLATE = [
                ['core/heading', { level: 2, placeholder: 'Title', className: 'hero-heading' }],
                ['core/paragraph', { placeholder: 'Description', className: 'hero-description' }]
            ];

            const renderVideoPreview = () => {
                if (videoSource === 'local') {
                    if (!videoUrl) {
                        return (
                            <div style={{ padding: '40px', background: '#f7f7f7', textAlign: 'center', border: '1px solid #ddd' }}>
                                <p style={{ margin: '0 0 15px 0', fontSize: '14px', color: '#666' }}>No video selected</p>
                                <MediaUpload
                                    onSelect={onSelectVideo}
                                    allowedTypes={['video']}
                                    value={videoId}
                                    render={({ open }) => (
                                        <Button onClick={open} isPrimary>Upload/Select Video</Button>
                                    )}
                                />
                            </div>
                        );
                    }
                    return (
                        <video autoPlay loop muted playsInline style={{ width: '100%', maxHeight: '400px' }}>
                            <source src={videoUrl} type="video/mp4" />
                        </video>
                    );
                }

                if (!externalUrl) {
                    return (
                        <div style={{ padding: '40px', background: '#f7f7f7', textAlign: 'center', border: '1px solid #ddd' }}>
                            <p style={{ margin: '0', fontSize: '14px', color: '#666' }}>
                                Paste a {videoSource === 'youtube' ? 'YouTube' : ''} URL in the panel to preview.
                            </p>
                        </div>
                    );
                }

                return (
                    <video
                        id="bgvid"
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ width: '100%', height: '400px', objectFit: 'cover', display: 'block' }}
                    >
                        <source src={embedUrl} type="video/mp4" />
                    </video>
                );
            };

            return (
                <Fragment>
                    <InspectorControls>
                        <PanelBody title="Video Settings" initialOpen={true}>

                            <SelectControl
                                label="Video Source"
                                value={videoSource}
                                options={[
                                    { label: 'Local (Media Library)', value: 'local' },
                                    { label: 'YouTube', value: 'youtube' },
                                    { label: 'External iFrame URL', value: 'iframe' },
                                ]}
                                onChange={(val) => setAttributes({ videoSource: val })}
                            />

                            {videoSource === 'local' && (
                                <div style={{ marginTop: '15px' }}>
                                    <MediaUpload
                                        onSelect={onSelectVideo}
                                        allowedTypes={['video']}
                                        value={videoId}
                                        render={({ open }) => (
                                            <Button onClick={open} isDefault isLarge>
                                                {videoUrl ? 'Change Video' : 'Select Video'}
                                            </Button>
                                        )}
                                    />
                                    {videoUrl && (
                                        <Fragment>
                                            <Button onClick={removeVideo} isLink isDestructive style={{ marginTop: '10px', display: 'block' }}>
                                                Remove Video
                                            </Button>
                                            <p style={{ marginTop: '8px', fontSize: '12px', color: '#555' }}>
                                                Current: {videoUrl.split('/').pop()}
                                            </p>
                                        </Fragment>
                                    )}
                                </div>
                            )}

                            {(videoSource === 'youtube' || videoSource === 'iframe') && (
                                <div style={{ marginTop: '15px' }}>
                                    <TextControl
                                        label={videoSource === 'youtube' ? 'YouTube URL' : 'iFrame URL'}
                                        placeholder={
                                            videoSource === 'youtube'
                                                ? 'https://youtu.be/xxxx or youtube.com/watch?v=xxxx'
                                                : 'https://example.com/embed/video'
                                        }
                                        value={externalUrl}
                                        onChange={onExternalUrlChange}
                                    />
                                    {videoSource === 'youtube' && externalUrl && !isYouTubeUrl(externalUrl) && (
                                        <p style={{ color: '#c00', fontSize: '12px', margin: '4px 0 0' }}>
                                            URL doesn't look like a valid YouTube link.
                                        </p>
                                    )}
                                    {externalUrl && (
                                        <Button
                                            isLink isDestructive
                                            onClick={() => setAttributes({ externalUrl: '' })}
                                            style={{ marginTop: '8px' }}
                                        >
                                            Clear URL
                                        </Button>
                                    )}
                                </div>
                            )}

                        </PanelBody>
                    </InspectorControls>

                    <div className="video-background home-hero" style={{ border: '2px dashed #ccc', padding: '20px' }}>
                        <div className="video-wrap">
                            <div id="bgvid">
                                {renderVideoPreview()}
                            </div>
                        </div>
                        <div className="hero-content" style={{ 
                            position: 'relative', zIndex: 10, padding: '20px',
                            marginTop: '20px', background: 'rgba(34, 22, 82, 0.42)'
                        }}>
                            <InnerBlocks
                                allowedBlocks={ALLOWED_BLOCKS}
                                template={TEMPLATE}
                                templateLock={false}
                            />
                        </div>
                    </div>
                </Fragment>
            );
        },

        save({ attributes }) {
            const { videoSource, videoUrl, externalUrl } = attributes;

            const renderSavedVideo = () => {
                if (videoSource === 'local') {
                    if (!videoUrl) return null;
                    return (
                        <video id="bgvid" autoPlay loop muted playsInline>
                            <source src={videoUrl} type="video/mp4" />
                        </video>
                    );
                }
                if (!externalUrl) return null;
                const src = videoSource === 'youtube' ? buildYouTubeEmbedUrl(externalUrl) : externalUrl;
                return (
                    <video
                        id="bgvid"
                        autoPlay
                        loop
                        muted
                        playsInline
                        style={{ 
                            pointerEvents: 'none',
                            position: 'absolute',
                            top: '50%',
                            left: '50%',
                            transform: 'translate(-50%, -50%)',
                            width: '100vw',
                            height: '56.25vw',
                            minHeight: '105%',
                            minWidth: '177.77vh',
                            objectFit: 'cover',
                        }}
                    >
                        <source src={src} type="video/mp4" />
                    </video>
                );
            };

            const videoContent = renderSavedVideo();
            if (!videoContent) return null;

            return (
                <div className="video-background home-hero">
                    <div className="video-wrap">
                        <div id="bgvid">
                            {videoContent}
                        </div>
                    </div>
                    <div className="container hero-content">
                        <InnerBlocks.Content />
                    </div>
                </div>
            );
        },
    });
}